import { Diamond } from "lucide-react";
import { ListenShell } from "./listenShared";

export function ListenWelcome({ bookTitle, author, name, preview, cover, onStart }) {
  return (
    <ListenShell>
      <div className="relative flex flex-1 flex-col items-center justify-center px-8 text-center">
        <div className="animate-[fadeUp_0.7s_ease]">
          {cover ? (
            <img
              data-testid="listen-welcome-cover"
              src={cover}
              alt={bookTitle ? `${bookTitle} cover art` : "Cover art"}
              className="mx-auto h-44 w-44 rounded-2xl object-cover shadow-2xl shadow-black/50 ring-1 ring-white/10 sm:h-52 sm:w-52"
            />
          ) : (
            <Diamond className="mx-auto h-14 w-14 text-teal-300/90" strokeWidth={1.1} />
          )}
          <div className="mt-7 font-mono text-[10px] uppercase tracking-[0.5em] text-teal-300/70">
            {preview ? "Preview Mode" : "Beta Listener Preview"}
          </div>
          <h1 className="mt-4 font-serif text-4xl leading-tight tracking-tight text-slate-50 sm:text-5xl">
            {bookTitle || "House Diamond"}
          </h1>
          {author && <p className="mt-2 font-serif text-lg italic text-slate-400">{author}</p>}
          <p className="mt-10 text-base text-slate-300">
            Welcome{name ? <>, <span className="text-teal-200">{name.split(" ")[0]}</span></> : ""}.
          </p>
          <div data-testid="listen-disclaimer" className="mx-auto mt-4 max-w-sm rounded-2xl border border-white/5 bg-white/[0.02] px-5 py-4 text-left">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-teal-300/80">Listener Notice</p>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">
              This is an early preview of an unedited working manuscript, not a finished product. Please note that the narration is AI-generated, so you may encounter occasional quirks in pacing, phrasing, or pronunciation; please disregard those for now.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">
              This is a private preview, and your place is saved automatically, feel free to leave and return anytime.
            </p>
          </div>
          <button
            data-testid="listen-start-btn"
            onClick={onStart}
            className="group mt-10 inline-flex items-center gap-2 rounded-full bg-teal-400 px-9 py-3.5 text-sm font-semibold tracking-wide text-slate-950 transition-all hover:bg-teal-300 active:scale-[0.98]"
          >
            Start Listening
          </button>
        </div>
      </div>
      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}`}</style>
    </ListenShell>
  );
}
